import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  ApiDeleteInterface,
  ApiGetInterface,
  ApiParams,
  ApiPatchInterface,
  ApiPostInterface,
} from "@core/models/apiServiceInterface.interface";
import { environment } from "@environment/environment";
import { CustomHttpUrlEncodingCodec } from "@shared/utils/encoder";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getHttpParams(params: ApiParams): HttpParams {
    let httpParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          httpParams = httpParams.set(key, value.join(';'));
        } else {
          httpParams = httpParams.set(key, value);
        }
      }
    });
    return httpParams;
  }

  public get<T>(payload: ApiGetInterface): Observable<T> {
    payload.params = payload?.params ?? new HttpParams();
    return this.http.get<T>(`${environment.api_url}/${payload?.url}`, {
      headers: this.headers,
      params: payload?.params,
    });
  }

  public post<T>(payload: ApiPostInterface): Observable<T> {
    payload.params = payload?.params ?? new HttpParams();
    payload.header = payload?.header ?? this.headers;

    let data;
    if (payload.data instanceof FormData) {
      data = payload?.data
    } else {
      data = JSON.stringify(payload?.data)
    }
    return this.http.post<T>(
      `${environment.api_url}/${payload?.url}`,
      data,
      {
        headers: payload.header,
        params: payload?.params,
      }
    );
  }

  public patch<T>(payload: ApiPatchInterface): Observable<T> {
    return this.http.patch<T>(
      `${environment.api_url}/${payload?.url}`,
      JSON.stringify(payload?.data),
      {
        headers: this.headers
      }
    );
  }

  public put<T>(payload: ApiPatchInterface): Observable<T> {
    return this.http.put<T>(
      `${environment.api_url}/${payload?.url}`,
      JSON.stringify(payload?.data),

      {
        headers: this.headers
      }
    );
  }

  public delete<T>(payload: ApiDeleteInterface): Observable<T> {
    const options = {
      headers: this.headers,
      body: payload.data
    };
    return this.http.delete<T>(
      `${environment.api_url}/${payload.url}`,
      options
    );
  }

  public getFromThirdPartyUrl<T>(url: string): Observable<T> {
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Without-Auth": "true",
    };
    const headers = new HttpHeaders(headersConfig);

    return this.http.get<T>(url, { headers });
  }

  putThirdPartyServer(apiPostInterface: ApiPostInterface): Observable<unknown> {
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Without-Auth": "true",
    }
    const headers = new HttpHeaders(headersConfig)

    return this.http.put(apiPostInterface.url, apiPostInterface.data, {
      headers,
    })
  }

  getThirdPartyBlob(apiGetInterface: ApiGetInterface): Observable<Blob | MediaSource> {
    const headersConfig = {
      Accept: 'text/csv',
      'Without-Auth': 'true'
    };

    return this.http.get(apiGetInterface.url, {
      headers: new HttpHeaders(headersConfig),
      responseType: 'blob',
      params: apiGetInterface.params
    });
  }

  private get headers(): HttpHeaders {
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return new HttpHeaders(headersConfig);
  }

}
